import { ref, type Ref } from 'vue'

import AuthenticationService from '@/api/AuthenticationService'

/**
 * Tracks whether the signed-in user is a SuperAdmin. The status starts false
 * and only becomes trustworthy once `resolveSuperAdminStatus` has settled.
 */
export function useSuperAdminStatus(): {
  isSuperAdmin: Ref<boolean>
  resolveSuperAdminStatus: () => Promise<boolean>
  forgetSuperAdminStatus: () => void
} {
  const isSuperAdmin = ref<boolean>(false)

  async function resolveSuperAdminStatus(): Promise<boolean> {
    isSuperAdmin.value = await AuthenticationService.isSuperAdmin()

    return isSuperAdmin.value
  }

  function forgetSuperAdminStatus(): void {
    isSuperAdmin.value = false
  }

  return { isSuperAdmin, resolveSuperAdminStatus, forgetSuperAdminStatus }
}
